/* eslint-disable no-bitwise */
export enum UserFlag2 {
  ConvertBuyIn = 1 << 4,
  ConvertWinnings = 1 << 5,
  NoLoginEmailNotification = 1 << 8,
  BannedByRegulator = 1 << 28,
  AccountPINGenerated = 1 << 0,
  RSAActivated = 1 << 1,
  PendingFunds = 1 << 20,
  MobileVerified = 1 << 16
}
